import React, { PureComponent } from 'react'
import { Form, Input, Checkbox, Tooltip, Icon } from 'antd'
import {
    infoRequired,
    validateName,
    validateTelefone,
    validateEmail,
    validatePassword,
} from '../../../utils/validators'
import {
    maskCpfOnChange as maskCpf,
    maskTelefoneOnChange as maskTelefone,
    maskNomeOnChange,
    alphaOnlyOnChange,
    maskCepOnChange as maskCep
} from '../../../utils/masks'
import 'moment/locale/pt-br'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import theme from '../../../config/theme'

const NomeCelular = () => (
    <>Celular<Tooltip className="ml-2" title="Certifique-se de que o número de celular está correto. Poderemos solicitar verificação via SMS em alguns de nossos serviços."><FontAwesomeIcon icon={faInfoCircle} /></Tooltip></>
)

const FormCadastro = Form.create({ name: 'form-cadastro' })(
    ({form, handleSubmit, disabled, checkPassword, strength, onChangeEmail, referralCode}) => {
        return (
            <Row>
                <Form layout="vertical" onSubmit={handleSubmit(form)}>
                <Col md={6} className='p-0 pr-2'>
                    <Form.Item label="Nome Completo">
                        {form.getFieldDecorator('nome', {
                            rules: [
                                infoRequired,
                                validateName()
                            ]
                        })(
                            <Input placeholder="Nome Completo" onChange={maskNomeOnChange} onKeyPress={maskNomeOnChange} />
                        )}
                    </Form.Item>
                </Col>
                <Col md={6} className='p-0 pl-2'>
                    <Form.Item label={<NomeCelular />}>
                        {form.getFieldDecorator('telefone', {
                            rules: [
                                infoRequired,
                                validateTelefone()
                            ]
                        })(
                            <Input placeholder="Número de celular" onChange={maskTelefone} onKeyPress={maskTelefone} />
                        )}
                    </Form.Item>
                </Col>
                <Col md={6} className='p-0 pr-2'>
                    <Form.Item label="E-mail">
                        {form.getFieldDecorator('email', {
                            rules: [
                                infoRequired,
                                validateEmail()
                            ]
                        })(
                            <Input type="email" placeholder="E-mail" onChange={onChangeEmail} />
                        )}
                    </Form.Item>
                </Col>
                <Col md={6} className='p-0 pl-2'>
                    <Form.Item label="Confirme seu e-mail">
                        {form.getFieldDecorator('confirmEmail', {
                            rules: [
                                {
                                    validator: (_, value, callback) => {
                                        if (value && value !== form.getFieldValue('email')) {
                                            callback('Os e-mails informados não correspondem')
                                        } else {
                                            callback()
                                        }
                                    }
                                }
                            ]
                        })(
                            <Input type="email" placeholder="Confirme seu e-mail" />
                        )}
                    </Form.Item>
                </Col>
                <Col md={12} className='p-0'>
                    {referralCode && (
                        <Form.Item label="Código de Indicação">
                            {form.getFieldDecorator('referralCode', {
                                rules: [],
                                initialValue: referralCode
                            })(
                                <Input placeholder="Código de Indicação" disabled />
                            )}
                        </Form.Item>
                    )}
                </Col>
                <Col md={6} className='p-0 pr-2'>
                    <Form.Item label="Senha">
                        {form.getFieldDecorator('senha', {
                            rules: [
                                infoRequired,
                                validatePassword()
                            ]
                        })(
                            <Input.Password placeholder="Senha" onChange={checkPassword} />
                        )}
                    </Form.Item>
                </Col>
                <Col md={6} className='p-0 pl-2'>
                    <Form.Item label="Confirme sua senha">
                        {form.getFieldDecorator('confirmSenha', {
                            rules: [
                                {
                                    validator: (_, value, callback) => {
                                        if (value && value !== form.getFieldValue('senha')) {
                                            callback('As senhas informadas não correspondem')
                                        } else {
                                            callback()
                                        }
                                    }
                                }
                            ],
                        })(
                            <Input.Password placeholder="Confirme sua senha" />
                        )}
                    </Form.Item>
                </Col>
                <Col md={6} className='d-flex justify-content-between p-0 pr-2'>
                    <div className='colPassword'>
                        <div className='nivelSenha' style={{backgroundColor: strength === 1 && "#D10B57"}}/>
                        <p>Fraca</p>
                    </div>
                    <div className='colPassword'>
                        <div className='nivelSenha' style={{backgroundColor: strength === 2 && "#F9B815"}}/>
                        <p>Média</p>
                    </div>
                    <div className='colPassword'>
                        <div className='nivelSenha' style={{backgroundColor: strength === 3 && "#15F955"}} />
                        <p> Forte</p>
                    </div>
                </Col>

                <Col md={6}/>
                
                <Col md={6} className='d-flex flex-column p-0 pr-2 mt-3'>
                    <p className='regraSenha'>&bull; A senha deve ter no mínimo 8 digitos;</p>
                    <p className='regraSenha'>&bull; Ter no mínimo um caractere especial;</p>
                    <p className='regraSenha'>&bull; Ter no mínimo uma letra maiúscula;</p>
                </Col>
                <Col md={6} className='d-flex flex-column p-0 pl-2 mt-3 passRules'>
                    <p className='regraSenha'>&bull; Ter no mínimo um número;</p>
                    <p className='regraSenha'>&bull; Não pode ter sequência alfanumérica.</p>
                </Col>


                <Col md={12} className='mt-4 mb-3  text-center'>
                    <Form.Item className='pb-0 mb-0'>
                        {form.getFieldDecorator('checkbox', {
                            rules: [ infoRequired ]
                        })(
                            <Checkbox className='text-white'>Li e concordo com a <Link to="#" target="_blank" className="font-weight-bold" style={{ color: theme.colors.primary }}>Política de Privacidade</Link></Checkbox>
                        )}
                    </Form.Item>
                </Col>

                <Col md={12}>
                    <Form.Item>
                        <button 
                            type="submit" 
                            className="anchorBtn w-100 buttonRegistro"
                            style={{
                                backgroundColor: theme.colors.primary,
                                color: theme.colors.white,
                                fontFamily: theme.typography.fontFamily.bold,
                                fontSize: theme.typography.fontSize.medium,
                                borderRadius: theme.borderRadius.medium,
                                border: `2px solid ${theme.colors.primary}`,
                                transition: '0.3s ease',
                                height: '40px',
                                '&:hover': {
                                    backgroundColor: theme.colors.primaryHover,
                                    borderColor: theme.colors.primaryHover
                                }
                            }}
                        >
                            {disabled ? <Icon type="loading" /> : "Abrir Conta"}
                        </button>
                    </Form.Item>
                </Col>
            </Form>
            </Row>
        )
    }
)

class ClassFormCadastro extends PureComponent {
    constructor(props) {
        super();
        this.state = {
            strength: 0
        }
    }

    checkPassword = (e) => {
        const pass = e.target.value
        if(pass.length === 0) {
            this.setState({ strength: 0 })
        } else {
            if(pass.length <= 8) {
                this.setState({ strength: 1 })
            }
            if(pass.length >= 8 && pass.match(/[A-Z]/) && pass.match(/\d/)) {
                this.setState({ strength: 2 })
            }
            if(pass.length >= 8 && pass.match(/[A-Z]/) && pass.match(/\d/) && pass.match(/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/)) {
                this.setState({ strength: 3 })
            }
        }
        
    }

    render()     
    {
        const { handleSubmit, disabled, onChangeEmail, referralCode } = this.props    
        return(
                <FormCadastro handleSubmit={handleSubmit} disabled={disabled} checkPassword={this.checkPassword} strength={this.state.strength} onChangeEmail={onChangeEmail} referralCode={referralCode} />
            )
            
    }
}

export default ClassFormCadastro